import { FormGroup, TextArea } from "@blueprintjs/core";
import React from "react";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FieldLabeledProps, TextAreaProps } from "../../types/fieldTypes";
import { useTextAreaField } from "./useTextAreaField";

export interface TextAreaFieldProps extends TextAreaProps {
  labelProps?: FieldLabeledProps;
}

const TextAreaField: React.FC<TextAreaFieldProps> = (props) => {
  const { localValue, setLocalValue } = useTextAreaField(props);

  return (
    <div className="ucl-base-input-text-area-field-container">
      <FormGroup
        className={
          props.isRequired && !localValue
            ? "has-required-background"
            : "base-field"
        }
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValue }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        <TextArea
          name={String(props.label)}
          //defaultValue={props.value}
          value={localValue}
          maxLength={props.maxLength === 0 ? undefined : props.maxLength}
          disabled={props.disabled}
          readOnly={props.readOnly}
          placeholder={props.placeholder}
          onChange={(e) => {
            setLocalValue(e.target.value);
            props.onSubmit && props.onSubmit(e.target.value);
          }}
        />
        {!!props.maxLength && localValue && (
          <div className="text-area-remaining-characters">
            <FieldLabel
              labelName={`${props.maxLength - localValue.length} of ${
                props.maxLength
              } characters left`}
              isRequired={false}
            />
          </div>
        )}
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default TextAreaField;
